import type {
  BackgroundOperationKey,
  SerializedBackgroundOperationKey,
} from '../types/background-operation-key.type';

export const serializeBackgroundOperationKey = (
  key: Readonly<BackgroundOperationKey>,
): SerializedBackgroundOperationKey =>
  key.identifier ? `${key.type}:${key.identifier}` : key.type;
